import React from 'react'

const getPostCatName = {
	'news-roubaixxxl': 'Actu Roubaixxl.fr',
	'events-openagenda': 'Evénement',
	'page': 'Contenu'
}

const SearchItemCatName = ({postItem, postItemMini}) => {
	// Vérification de sécurité pour éviter les erreurs
	if (!postItem || !postItem._source || !postItem._source.post_type) {
		return null
	}

	const { post_type } = postItem._source
	
	// Vérification que post_type est une chaîne valide
	if (typeof post_type !== 'string' || post_type.trim() === '') {
		return null
	}

	const categoryName = getPostCatName[post_type] || 'Annuaire'

	return (
		<p className={`search-list-item-head-cateory ${postItemMini ? 'search-list-mini-item-head-category' : ''}`}>
			<span dangerouslySetInnerHTML={{ __html: categoryName }}></span>
		</p> 
	)
}

export default SearchItemCatName